// import { useCallback } from "react";
import { Button } from "@material-ui/core";
import {
  Elements,
  // CardElement,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import useRazorpay from "react-razorpay";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const Payment = ({
  user,
  checkoutData,
  handleBackStep,
  handleNextStep,
  handleCheckout,
}) => {
  // console.log('payment details users', checkoutData.live.subtotal);

  const Razorpay = useRazorpay();

  const handlePayment = (e) => {
    // const order = await createOrder(params);

    const n = checkoutData.live.subtotal.raw;
    const num = n + '00';

    const RazorpayOptions = {
      key: "rzp_test_6qYV8zGbXgMq2m",
      description: 'Credits towards consultation',
      image: 'https://i.imgur.com/3g7nmJC.png',
      currency: 'INR',
      amount: num,
      name: user.firstName,
      handler: (res) => {
        console.log(res);
        if(res.razorpay_payment_id !== '') {
          handleCheckout(checkoutData.id, RazorpayOptions);
          handleNextStep(e, "confirmation");
        }
      },
      prefill: {
        email: user.email,
        contact: '9191919191',
        name: 'Razorpay Software'
      },
      theme: { color: '#F37254' }

    };
    // handleCheckout(checkoutData.id, RazorpayOptions);
    // handleNextStep(e, "confirmation");

    const rzpay = new Razorpay(RazorpayOptions);
    rzpay.open("payment.success", function (response) {
      console.log('check', response);
    });
  
  };


  // const handleSubmit = async (e, elements, stripe) => {
  //   e.preventDefault();

  //   if (!stripe || !elements) return;

  //   const cardElement = elements.getElement(CardElement);

  //   const { error } = await stripe.createPaymentMethod({
  //     type: "card",
  //     card: cardElement,
  //   });

  //   if (error) {
  //     console.log("Error ======>>>>", error);
  //   } else {
  //     const orderData = {
  //       payment: {
  //         gateway: "stripe",
  //         stripe: {
  //           payment_method_id: paymentMethod.id,
  //         },
  //       },
  //       shipping: {
  //         name: "stander",
  //         street: user.address,
  //         town_city: user.city,
  //         county_state: "Delhi",
  //         postal_zip_code: user.postcode,
  //         country: "India",
  //       },
  //       customer: {
  //         firstname: user.firstName,
  //         lastname: user.lastName,
  //         email: user.email,
  //       },
  //       line_items: checkoutData.live.line_items,
  //       fulfillment: { shipping_method: "" },
  //     };

  //     handleCheckout(checkoutData.id, orderData);
  //     handleNextStep(e, "confirmation");
  //   }
  // };

  return (
    <>
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => (
            // <form onSubmit={(e) => handleSubmit(e, elements, stripe)}>
            // <CardElement />
            <div className="actions payment-actions">
              <Button
                variant="outlined"
                onClick={(e) => handleBackStep(e, "order-details")}
              >
                Back
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={!stripe}
                color="primary"
                onClick={handlePayment}
              >
                Pay {checkoutData.live.subtotal.formatted_with_symbol}
              </Button>
              {/* <Button
                  variant="outlined"
                  onClick={(e) => handleBackStep(e, "order-details")}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!stripe}
                  color="primary"
                  onClick={handlePayment}
                >
                  Pay {checkoutData.live.subtotal.formatted_with_symbol}
                </Button> */}
            </div>
            // </form>
          )}
        </ElementsConsumer>
      </Elements>
    </>
  );
};

export default Payment;